import React from "react"

function Person({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.9924 18.5545C21.0971 18.5545 23.6139 16.0376 23.6139 12.933C23.6139 9.82834 21.0971 7.31152 17.9924 7.31152C14.8878 7.31152 12.3709 9.82834 12.3709 12.933C12.3709 16.0376 14.8878 18.5545 17.9924 18.5545Z"
        stroke="#003E4C"
        strokeWidth="1.00321"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7049 20.8409C13.7049 20.8409 11.2389 21.9254 10.3704 22.3074C10.1854 22.3884 10.0588 22.5622 10.0374 22.763C9.93168 23.7541 9.61274 26.7568 9.4738 28.0663C9.45694 28.2255 9.50813 28.3835 9.61501 28.5022C9.7213 28.6209 9.87318 28.6884 10.0329 28.6884C12.7223 28.6884 23.2854 28.6884 25.9669 28.6884C26.1261 28.6884 26.2774 28.6214 26.3843 28.5033C26.4906 28.3858 26.5423 28.2283 26.5266 28.0702C26.3966 26.7714 26.0996 23.8008 26.0006 22.8153C25.9809 22.6145 25.8549 22.4401 25.671 22.3574C24.7873 21.9626 22.2426 20.8252 22.2426 20.8252"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Person
